var module = angular.module('octopusApp.infrastructure');

module.directive('detailedHelpToggle', function () {
    return {
        restrict: 'AC',
        replace: false,
        link: function (scope, element) {
            element.click(function () {
               element.hide();
                element.closest("p").siblings(".detailed-help").fadeIn(200);
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/detailed_help_toggle.js
// module id = 6860255960679064
// module chunks = 1